import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const AddPromotion=({token,promotion}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/promotions/add`,promotion)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ChangePromotionsVisibility=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/promotions/changeVisibility`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeletePromotion=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/promotions/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeletePromotions=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/promotions/bulkDelete`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetPromotion=({token,_id, venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/promotions/${_id}`, {venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetPromotions=({token, _id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/promotions/`, {_id})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeletePromotion=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/promotions/undelete/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeletePromotions=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/promotions/undelete/bulk`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UpdatePromotion=({token,promotion}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/promotions/update/${promotion._id}`,promotion)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

export {
    AddPromotion,
    ChangePromotionsVisibility,
    DeletePromotion,
    DeletePromotions,
    GetPromotion,
    GetPromotions,
    UnDeletePromotion,
    UnDeletePromotions,
    UpdatePromotion
}


